import actionTypes from '../../../redux/actionTypes'

export const setUserTypes = (types) => ({
  type: actionTypes.SET_USER_TYPES,
  payload: types
})
